<template>
<div>
  <div
    class="layer2"
    v-for="(i, index) in elements"
    :key="index"
    :style="{
      top: i.top + 'mm',
      left: i.left + 'mm',
      width: i.width + 'mm',
      height: i.height + 'mm',
    }"
  >
    <div :style="{ color: i.content.color }">
      <div class="icon-box" v-if="i.content.icon">
        <div>
          <i
            v-if="
              i.style.constrain == 1 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            "
            :class="i.content.icon"
            class="iconfont2"
            :style="{
              fontSize: i.iconSize + 'mm',
              position: 'absolute',
              left: i.iconCords.x - i.iconSize / 2 - 2 + 'mm',
              top: i.iconCords.y - i.iconSize / 2 - 2 + 'mm',
            }"
          ></i>
        </div>
      </div>
      <div class="text-box" v-if="i.content.textL1 || i.content.textL2">
        <div>
          <p
            :ref="'textL1_' + i.id"
            v-if="
              i.style.constrain == 2 ||
              i.style.constrain == 3 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            "
            class=""
            :style="{
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - textL1width['textL1_' + i.id] + 'mm',
              top: i.textCords.y - 2 + 'mm',
              whiteSpace: 'pre',
              letterSpacing: letterSpacing,
              fontKerning: 'none'
            }"
          >{{i.content.textL1}}</p>
          <p
            :ref="'textL2_' + i.id"
            v-if="i.style.constrain == 3 || i.style.constrain == 5"
            class=""
            :style="{
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - textL2width['textL2_' + i.id] + 'mm',
              top: i.textCords.y - 2 + i.textL2Offset + 'mm',
              whiteSpace: 'pre',
              letterSpacing: letterSpacing,
            }"
          >{{i.content.textL2}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "EngravingElements",
  props: ["elements"],
  data() {
    return {
      textL1width: {},
      textL2width: {},
      letterSpacing: '0.125px' // 0.25mm
    };
  },
  watch: {
    "$store.state.artwork": {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.setTextWidths(newVal);
        this.$nextTick(() => {
          this.setTextWidths(newVal);
        });
      },
    },
  },
  methods: {
    setTextWidths(val) {
        this.getTextWidths(val.content.entries())
        if (val.format != "single") {
            this.getTextWidths(val.rightContent.entries())
        }
        if (val.format == "triple") {
            this.getTextWidths(val.tripleRightContent.entries())
        }

    },
    getTextWidths(val) {
      for (let [index, v] of val) {
        if (typeof this.elements[index] == "undefined") continue;
        if (
          this.elements[index].alignment.textL1 == "P4" ||
          this.elements[index].alignment.textL1 == "P5" ||
          this.elements[index].alignment.textL1 == "P6"
        ) {
          if (v.textL1 && this.$refs['textL1_' + index].length > 0) {
            this.textL1width["textL1_" + index] =
              this.$refs['textL1_' + index][0].offsetWidth *
                0.264583 +
              2;
          }
          if (v.textL2 && this.$refs['textL2_' + index].length > 0) {
            this.textL2width["textL2_" + index] =
              this.$refs['textL2_' + index][0].offsetWidth *
                0.264583 +
              2;
          }
        } else if (this.elements[index].alignment.textL1 == "P7") {
          if (v.textL1 && this.$refs['textL1_' + index].length > 0) {
            this.textL1width["textL1_" + index] =
              (this.$refs['textL1_' + index][0].offsetWidth *
                0.264583) /
                2 +
              2;
          }
          if (v.textL2 && this.$refs['textL2_' + index].length > 0) {
            this.textL2width["textL2_" + index] =
              (this.$refs['textL2_' + index][0].offsetWidth *
                0.264583) /
                2 +
              2;
          }
        } else {
          this.textL1width["textL1_" + index] = 2;
          this.textL2width["textL2_" + index] = 2;
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
